import { DonutChart } from "./index";
import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

function LocationReport({ data, containerFlow }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierDashboard.charts"
  });
  const getDonutChartData = () => {
    return [
      {
        id: 1,
        value: data,
        label: "Location Total Emissions",
        "color": "hsl(20, 70%, 50%)"
      }
    ];
  };

  return (
    <Box paddingInlineStart={containerFlow === "row" ? 2 : 0}>
      <Text fontSize="xl" fontWeight="600">
        {t("location")} {t("emissionsDataOverview")}
      </Text>
      <Box height={"300px"}>
        <DonutChart data={getDonutChartData()} />
      </Box>
    </Box>
  );
}

export default LocationReport;